export enum Theme {
    Default = 'default',
    PoligrafBG = 'poligraf-bg'
}
